var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 center"},[_c('h1',[_vm._v(_vm._s(_vm.$("res_Msgs_Redirecting")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }